import React from 'react';
import {SelectElement} from '@damascus-components/SelectElement';
// import {Select as SelectElement} from '@components/Select';
import {SelectProps as Props} from './Select.type';
import {FormControl} from '@mui/material';

import cn from './Select.module.scss';

// eslint-disable-next-line react/display-name
export const Select = React.forwardRef(({className, ...props}: Props, ref) => {
  const isSelected = props.value ? true : false;
  return (
    <FormControl className={cn.formControl}>
      <SelectElement
        {...props}
        className={`${isSelected ? cn.selected : ''} ${className} `}
        SelectRef={ref}
        isClear
      />
    </FormControl>
  );
});
